type Props = { data: any; i: number };

const CommissionsRow = ({ data, i }: Props) => {
  return (
    <div className="flex items-center gap-3 p-4 text-sm font-normal rounded-lg shadow-md text-color-primary max-3xl:grid">
      <span>COM{i + 1}</span>
      <div className="py-2 px-3 text-[#020418] rounded-lg capitalize bg-[#EEF0FF]">
        {data?.commissions?.map((e: any, i: number) => (
          <span key={i}>
            {e?.value}%{i < data.commissions.length - 1 ? " - " : ""}
          </span>
        ))}
      </div>
      <div className="flex items-center gap-3">
        {data?.commissions?.map((e: any, i: number) => (
          <span className="capitalize" key={i}>
            {e?.commission_type} {i < data.commissions.length - 1 ? " - " : ""}
          </span>
        ))}
      </div>
    </div>
  );
};

export default CommissionsRow;
